import { EMPLOYEE_SECTION_UPDATE, generateColumn } from '../../supplementary_components/itemEditMethods';
import { addNotification } from "../../supplementary_components/store";
import { API_ROOT } from '../../supplementary_components/requests';
import { getCachedOrgRoles } from './employeeAddConf';
import { LatestActivitiesSection } from "../../general_components/content_management/item_page/latestActivitiesSection";
import { generateRandomString } from "../../supplementary_components/supplementaryMethods";

export class EMPLOYEE_PAGE_OBJECT {
    data;
    InfoSectionColumns = (skipFirst)=>{
            const array = [
                generateColumn(this.data, false, "First Name", 'firstName'),
                generateColumn(this.data, false, "Last Name", 'lastName'),
                generateColumn(this.data, false, "Telegram", 'telegramUserName'),
                generateColumn(this.data, true, "Status", 'active',{
                     customDisplayFormat : (val)=>{return val?"Active":"Inactive"},
                     type: "select",
                     dataset: ["Active", "Inactive"],
                     defaultValueGenerator : (val)=>{return val?"Active":"Inactive"},
                     customDefaultInputValue : this.active?"Active":"Inactive",
                     processBeforeSending : (val)=>{
                        return val === "Active";
                     }

                }),
                generateColumn(this.data, false, "Username", 'login'),
                generateColumn(this.data, false, "Email", 'email'),
                generateColumn(this.data, true, "Role", 'role',{
                    type: "select",
                    dataset: () => getCachedOrgRoles().map((role) => ({
                        id: role.id,
                        name: role.name,
                        value: String(role.id),
                        label: role.name,
                    })),
                    customDisplayFormat : () => this.data.roleName || '-',
                    customDefaultInputValue : this.data.roleId != null ? String(this.data.roleId) : '',
                    processBeforeSending:(val)=>{
                        const id = parseInt(val, 10);
                        return Number.isFinite(id) ? { id } : null;
                    },
                }),
                generateColumn(this.data, false, "Empoyee Of", 'accessibleCompanies',{
                    customDisplayFormat : () => {
                        let value = '';
                        (this.data.accessibleCompanies || []).forEach(element => {
                            value+= `${element["companyName"]}\n`
                        });
                        return value;
                    },
                    
                }),
                generateColumn(this.data, false, "Phone", 'directLine'),
                generateColumn(this.data, false, "Ext", 'extension'),
            ]
            if(skipFirst)array.shift();
            return array;
        }
    constructor(){
        this.getLink = API_ROOT+"employees/";
        this.columnProportions = "22rem 1fr 0.6fr";
    }
    setData(data){
        this.data = data;
        this.id = data['id'];
        this.firstName = data['firstName'];
        this.lastName = data['lastName'];
        this.telegramUserName = data['telegramUserName'];
        this.active = data['active'];
        this.login = data['login'];
        this.email = data['email'];
        this.password = data['password'];
        this.isCredentialsNonExpired = data['isCredentialsNonExpired'];
        this.isAccountNonLocked = data['isAccountNonLocked'];
        this.isAccountNonExpired = data['isAccountNonExpired'];
        this.directLine = data['directLine'];
        this.extension = data['extension'];
        this.notes = data['notes'];

        this.header = {
            title: this.firstName,
            suplementaryInfo: this.lastName
        };
        this.infoSections = [
            {
                title: 'Employee Details',
                editAccessLevel: { key: 'USERS', level: 'MANAGE' },
                copyButton: () => {
                    navigator.clipboard.writeText
                    (
                       `First name: ${this.firstName};
                        Last name: ${this.lastName};
                        Telegram: ${this.telegramUserName};
                        Email: ${this.email};
                        Phone Number: ${this.directLine}`
                    )
                    addNotification({message:`Copied to clipboard`, type:'notify', duration: '1000'})
                },
                editButton : {
                    text: 'Edit',
                    action: (setDataMethod)=>{
                        EMPLOYEE_SECTION_UPDATE(setDataMethod, this.data.id, this.InfoSectionColumns)
                    }
                },
                columns : this.InfoSectionColumns(false)
            },
        ]
        this.overviewSection = [
            {
                title: 'Performance of '+this.firstName + ' '+this.lastName+' for this week:'
            },
            {
                title: 'Latest Activities',
                headerLine: true,
                content: () => (
                    <LatestActivitiesSection
                        type="EMPLOYEE"
                        objectId={this.id}
                        refreshKey={generateRandomString(4)}
                    />
                ),
            }
        ]
        this.notesSection = {

        }

    }
}
